import FullCoverageWarrantyWrapper from "@components/layouts/fullCoverageWarrantyWrapper";
import CategoryForm from "@components/fullcoveragewarranty/categoryForm";
import { getPageProps } from "@services/initial-calls";
import { GetServerSideProps } from "next";
import React, { ReactElement } from "react";
import { DomainForm } from "src/api";
import { useDomainContext } from "@hooks/useDomainContext";
import WhatIsHomeWarrantyCategoryPage from "@components/fullcoveragewarranty/whatIsHomeWarrantyCategoryPage";
import HowIsHomeWarranty from "@components/fullcoveragewarranty/howIsHomeWarranty";
import WhoIsHomeWarranty from "@components/fullcoveragewarranty/whoIsHomeWarranty";
import CarWarranty from "@components/fullcoveragewarranty/carWarranty";
import WhatIsCarWarrantyCategoryPage from "@components/fullcoveragewarranty/whatIsCarWarrantyCategoryPage";
import CarWarrantyCover from "@components/fullcoveragewarranty/carWarrantyCover";
import {
    AllowedSlugsAuto,
    AllowedSlugsHome,
} from "@components/fullcoveragewarranty/categoryForm";

export default function CategoryPage({
    form,
}: {
    form: DomainForm;
}): ReactElement {
    const { category } = useDomainContext();

    return (
        <FullCoverageWarrantyWrapper>
            <CategoryForm form={form} />
            {AllowedSlugsHome.includes(category?.slug as string) && (
                <>
                    <WhatIsHomeWarrantyCategoryPage />
                    <HowIsHomeWarranty />
                    <WhoIsHomeWarranty />
                </>
            )}
            {AllowedSlugsAuto.includes(category?.slug as string) && (
                <>
                    <CarWarranty />
                    <WhatIsCarWarrantyCategoryPage />
                    <CarWarrantyCover />
                </>
            )}
        </FullCoverageWarrantyWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "category");
};
